import secureApi from '../../utils/secureApi';

export interface WeeklyReportAddPayload {
  tournament?: string | {
    _id: string;
    name: string;
    startDate: string;
    endDate: string;
  };
  tournamentSeason?: string;
  title: string;
  desc: string;
  images: string[];
  html: string;
  dateUploaded?: string;
  slug?: string;
  tag?: string;
  publishDate?: string;
  publishTime?: string;
}

export async function addWeeklyReport(payload: WeeklyReportAddPayload) {
  const response = await secureApi.post<any>(
    `/api/v2/tournaments/admin/weeklyReports/add`,
    payload
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && response._id) {
    return response; // Already the expected structure
  } else if (response && response.data && response.data._id) {
    return response.data; // Wrapped in data field
  }
  return response; // Fallback
} 